export default function Features() {
  const features = [
    {
      icon: 'ri-lock-password-line',
      title: 'Military-Grade Encryption',
      description: 'Advanced AES 256-bit encryption protects your data from hackers, ISPs, and government surveillance, ensuring complete privacy for all your online activities.'
    },
    {
      icon: 'ri-earth-line',
      title: 'Global Server Network',
      description: 'Connect to our extensive network of optimized servers in over 50 countries worldwide, ensuring fast speeds and reliable connections wherever you are.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'No-Logs Policy',
      description: 'We maintain a strict zero-logs policy, meaning we never track, collect, or store your browsing history, connection logs, or any personal data.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'High-Speed Connection',
      description: 'Enjoy unlimited bandwidth with lightning-fast speeds optimized for streaming, gaming, and downloading without any throttling or restrictions.'
    },
    {
      icon: 'ri-devices-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously with one account. Compatible with Windows, Mac, iOS, Android, Linux, and browser extensions.'
    },
    {
      icon: 'ri-shut-down-line',
      title: 'Kill Switch Protection',
      description: 'Automatic kill switch instantly disconnects your internet if VPN connection drops, preventing any data leaks and maintaining your privacy at all times.'
    }
  ];

  return (
    <section id="features" className="bg-[#F8FAFB] py-28">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-start justify-between mb-16">
          <div className="w-3/5">
            <div className="inline-block mb-6 px-5 py-2 bg-[#00D9FF] rounded-full">
              <span className="text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">FEATURES</span>
            </div>
            <h2 className="text-5xl font-bold text-[#0A1628] leading-tight">
              Why Choose<br />Our VPN
            </h2>
          </div>
          <div className="w-2/5">
            <p className="text-[#5A6B7F] text-lg leading-relaxed">
              Experience the ultimate in online privacy and security with features designed to keep you safe and anonymous while browsing the internet.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-10 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-[#00D9FF] to-[#00B8D4] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#0A1628] mb-4">{feature.title}</h3>
              <p className="text-[#5A6B7F] text-base leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
